
import { ISteroidogenesisInhibitorOther } from './SteroidogenesisInhibitorOther.types';

export const initialSteroidogenesisInhibitorOther: ISteroidogenesisInhibitorOther = {
  title: '',
  dose: '',
  dateStart: null,
  dateEnd: null,
  dateEndIsActive: false
}